<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="macaddresses"
      :items-per-page="10"
      :loading="loading"
      @click:row="(item) => openEditDialog(item)"
      class="table-cursor"
    >
      <template v-slot:item.updatedAt="{ item }">
        {{ getInternationalDate(item.updatedAt) }}
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ getInternationalDate(item.createdAt) }}
      </template>
    </v-data-table>
    <edit-mac-adress-attribute-dialog
      :attribute="editedItem"
      :open.sync="openDialog"
      v-if="openDialog"
    ></edit-mac-adress-attribute-dialog>
  </div>
</template>
<script>
import { ref, watch } from "@vue/composition-api";
import { useAttributes } from "@/composables/attribute";
import EditMacAdressAttributeDialog from "@/components/Attribute/EditMacAdressAttributeDialog";
import { date } from "@/composables/date";
export default {
  components: { EditMacAdressAttributeDialog },
  props: {
    macaddresses: Array,
    loading: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { deleteAttribute } = useAttributes();
    const { getInternationalDate } = date();

    /* Variables */
    const editedItem = ref({});
    const openDialog = ref(false);

    /* Méthodes */
    const openEditDialog = function (item) {
      editedItem.value = { ...item };
      openDialog.value = true;
    };

    /* Watchers */
    watch(
      () => openDialog.value,
      (newValue, oldValue) => {
        if (!newValue && oldValue) {
          emit("refresh-data");
        }
      },
      { deep: true }
    );

    return {
      headers: [
        { text: "Adresse", value: "value" },
        { text: "Commentaire", value: "comment" },
        { text: "Créée par", value: "createdBy" },
        { text: "Le", value: "createdAt" },
        { text: "Mise à jour par", value: "updatedBy" },
        { text: "Le", value: "updatedAt" },
      ],
      deleteAttribute,
      getInternationalDate,
      openEditDialog,
      openDialog,
      editedItem,
    };
  },
};
</script>
